import React, { useState } from 'react';
import { useLanguage } from '../LanguageContext';
import { CONTENT } from '../content';

export default function WhyJoin() {
  const { language } = useLanguage();
  const t = CONTENT[language].whyJoin;
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="bg-suncoast-offWhite rounded-2xl p-8 md:p-12">
      <div className="grid md:grid-cols-2 gap-12">
        {/* Bullets */}
        <div>
          <h3 className="text-2xl font-bold text-suncoast-dark mb-6">{t.title}</h3>
          <ul className="space-y-4">
            {t.bullets.map((bullet, i) => (
              <li key={i} className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-suncoast-primary text-white flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
                </div>
                <span className="text-gray-700 font-medium">{bullet}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Mini FAQ */}
        <div>
          <h4 className="text-lg font-bold text-suncoast-secondary mb-4 uppercase tracking-wide">{t.faqTitle}</h4>
          <div className="space-y-2">
            {t.faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <button 
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between p-4 text-left font-bold text-gray-700 hover:bg-gray-50"
                >
                  <span className="text-sm">{faq.q}</span>
                  <span className="text-suncoast-primary">{openIndex === index ? '−' : '+'}</span>
                </button>
                {openIndex === index && (
                  <div className="p-4 pt-0 text-sm text-gray-600 bg-gray-50 border-t border-gray-100">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
